import { useState } from "react"
import { floatUpAndGrow, popFromCenter } from "shared/styles/keyframes"
import { getRandomInt } from "shared/utils/getRandomInt"
import styled from "styled-components"

import CheckmarkSVG from "../assets/checkmark.svg"

const StyledCheckmark = styled(CheckmarkSVG)<{
  width: number
  left: number
  timeout: number
}>`
  opacity: 0;
  position: absolute;
  bottom: 0;
  width: ${(props) => props.width}px;
  left: calc(50% - ${(props) => props.width / 2 + props.left}px);
  pointer-events: none;
  animation: ${floatUpAndGrow} ${(props) => props.timeout}ms ease-out
    forwards;

  path {
    fill: #ffecec;
  }
`

const SingleCheckmark = styled(StyledCheckmark)<{
  width: number
  left?: number
  timeout: number
}>`
  bottom: calc(50% - ${(props) => props.width / 2}px);
  left: calc(50% - ${(props) => props.width / 2}px);
  animation: ${popFromCenter} ${(props) => props.timeout}ms ease-out
    forwards;

  path {
    fill: white;
  }
`

type CheckmarkProps = {
  onComplete?: () => void
  timeout?: number
}

export const MultiVoteCheckmark = ({
  timeout = 2000,
  onComplete = () => {},
}: CheckmarkProps) => {
  const width = 30
  const [left] = useState(getRandomInt(-25, 25))

  return (
    <StyledCheckmark
      width={width}
      left={left}
      onAnimationEnd={onComplete}
      timeout={timeout}
    />
  )
}

export const SingleVoteCheckmark = ({
  timeout = 1000,
  onComplete = () => {},
}: CheckmarkProps) => (
  <SingleCheckmark
    width={130}
    timeout={timeout}
    onAnimationEnd={onComplete}
  />
)
